import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';

import { Button } from '../../../../components';
import {
  Message,
  MessagesProvider,
} from '../../../../modules/Internationalization';

import Post from '../Post';
import { PostSkeleton } from '../Post/Skeleton';

import './style.scss';
import messages from './messages';
import { fetchPostsWithTag, fetchTotalPostsWithTag } from './utils';

const Posts = ({ categoryId = 'all' }) => {
  const [posts, setPosts] = useState([]);
  const [limit, setLimit] = useState(10);
  const [totalPosts, setTotalPosts] = useState(0);

  useEffect(
    () => {
      const loadPosts = async () => {
        setPosts(await fetchPostsWithTag(categoryId, limit));
      };

      loadPosts();
    },
    [categoryId, limit]
  );

  useEffect(
    () => {
      setPosts([]);
      setLimit(10);

      const loadTotalPosts = async () => {
        setTotalPosts((await fetchTotalPostsWithTag(categoryId)).length);
      };

      loadTotalPosts();
    },
    [categoryId]
  );

  const showLoadMoreButton = posts.length < totalPosts && posts.length !== 0;

  return (
    <MessagesProvider messages={messages}>
      {posts.length === 0 ? (
        <PostSkeleton />
      ) : (
        posts.map(props => (
          <Post
            {...props}
            // eslint-disable-next-line react/prop-types
            key={props.slug}
          />
        ))
      )}
      {showLoadMoreButton && (
        <Button
          onClick={() => {
            setLimit(limit + 10);
          }}
          className="border border-black mb-none"
          padded
        >
          <Message id="loadMore" />
        </Button>
      )}
    </MessagesProvider>
  );
};

Posts.propTypes = {
  categoryId: propTypes.string,
};

export default Posts;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Posts/index.js